module.exports = __webpack_public_path__ + "img/ground_default.a63a3953.jpg";